import { render, staticRenderFns } from "./OfficeTool.vue?vue&type=template&id=d7324eb0&scoped=true&"
import script from "./OfficeTool.vue?vue&type=script&lang=js&"
export * from "./OfficeTool.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTool.vue?vue&type=style&index=0&id=d7324eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7324eb0",
  null
  
)

export default component.exports